/**
 * API helpers for the auto-parts catalogue.
 * Kept in its own file so `lib/api.js` stays lean and testable.
 */
import { api } from "./api";

export const fetchParts = (params = {}) =>
  api.get("/parts", { params }).then((r) => r.data);
export const fetchPartsCount = (params = {}) =>
  api.get("/parts/count", { params }).then((r) => r.data);
export const fetchPart = (id) =>
  api.get(`/parts/${id}`).then((r) => r.data);
export const fetchRelatedParts = (id, limit = 4) =>
  api.get(`/parts/${id}/related`, { params: { limit } }).then((r) => r.data);
export const fetchPartsFacets = () =>
  api.get("/parts/facets").then((r) => r.data);
